'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024100 from "./presto.types$$anon$100.js";
import * as $j_presto$002etypes$0024$0024anon$002496 from "./presto.types$$anon$96.js";
import * as $j_presto$002etypes$0024$0024anon$002498 from "./presto.types$$anon$98.js";
import * as $j_presto$002etypes$0024$002dTime$002dRange$0024 from "./presto.types$-Time-Range$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$95() {
  this.c3g = null;
  this.c38 = null;
  this.c39 = false;
  this.c3h = null;
  this.c3i = false;
  this.c3l = null;
  this.c3e = null;
  this.c3f = false;
  this.c3a = null;
  this.c3b = false;
  this.c3c = null;
  this.c3d = false;
  this.c3j = false;
  this.c3k = false;
  this.c3g = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c3l = "TimeRange";
}
export { $c_Lpresto_types$$anon$95 as $c_Lpresto_types$$anon$95 };
$p = $c_Lpresto_types$$anon$95.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$95;
/** @constructor */
function $h_Lpresto_types$$anon$95() {
}
export { $h_Lpresto_types$$anon$95 as $h_Lpresto_types$$anon$95 };
$h_Lpresto_types$$anon$95.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.c3g;
});
$p.L = (function() {
  if ((!this.c39)) {
    this.c38 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c39 = true;
  }
  return this.c38;
});
$p.O = (function() {
  if ((!this.c3i)) {
    this.c3h = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c3i = true;
  }
  return this.c3h;
});
$p.E = (function() {
  return this.c3l;
});
$p.t = (function() {
  if ((!this.c3f)) {
    this.c3e = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("starts", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ends", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.c3f = true;
  }
  return this.c3e;
});
$p.M = (function() {
  if ((!this.c3b)) {
    this.c3a = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002etypes$0024$0024anon$002496.$c_Lpresto_types$$anon$96(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002etypes$0024$0024anon$002498.$c_Lpresto_types$$anon$98(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.c3b = true;
  }
  return this.c3a;
});
$p.Q = (function() {
  if ((!this.c3d)) {
    this.c3c = new $j_presto$002etypes$0024$0024anon$0024100.$c_Lpresto_types$$anon$100();
    this.c3d = true;
  }
  return this.c3c;
});
$p.w = (function() {
  if ((!this.c3k)) {
    this.c3j = false;
    this.c3k = true;
  }
  return this.c3j;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee144) => ((p) => \u03b4scrutinee144.cGG(p)))($j_presto$002etypes$0024$002dTime$002dRange$0024.$m_Lpresto_types$TimeRange$())));
});
var $d_Lpresto_types$$anon$95 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$95, "presto.types$$anon$95", ({
  Yj: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$95 as $d_Lpresto_types$$anon$95 };
//# sourceMappingURL=presto.types$$anon$95.js.map
